import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { find } from 'lodash-es';
import {PoolScope} from "@cbcore/NGRX/pool/pool.models";

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    template: '' // Base component has no template
})
export abstract class UnitsDistributionBase {
  @Input() leg!: PoolScope.Leg; // always provided by the host component
  @Input() isSepPool?: boolean;

  /**
   * Get units from distribution
   * Maintains existing functionality from UnitsDistributionDefault
   */
  protected getUnits(unit_distribution: any): number {
    try {
      const ud = find(unit_distribution, { prize_code: 'WIN' });
      return ud?.units || 0;
    } catch(e) {
      return 0;
    }
  }

  /**
   * Format display value - to be implemented by child components if needed
   */
  protected getDisplayValue(): string {
    return '';
  }

  /**
   * Format units - to be implemented by child components if needed
   */
  protected formatUnits(): string {
    return '';
  }
}
